function TestimonialsSection() {
  const testimonials = [
    { name: "Sumit Bhatia", amount: "₹1.10 Lakhs", text: "Received full payment for 1 year old payment through notice 🙏", emoji: "🎉" },
    { name: "Kiran Koshiya", amount: "₹2.64 Lakhs", text: "TOTAL RECEIVED PAYMENT in this month after implementing the formula 🔥🔥🔥", emoji: "💰" },
    { name: "Agam Rastogi", amount: "₹4.06 Lakhs", text: "Recovered with help of labour union, payment was 1.5-2 years old 🙏", emoji: "⚡" },
    { name: "Vinit Gupta", amount: "₹79,683", text: "6 months old payment recovered with PRE follow-up strategy 👍", emoji: "✅" },
    { name: "Amit Gupta", amount: "₹2.5 Lakhs", text: "2.5 lacs out of 4 lacs due to Notices and PRE techniques 👌", emoji: "📋" },
    { name: "Swapnil Ramrao", amount: "₹4 Lakhs", text: "1.5 years pending recovered with commitment failed strategy", emoji: "🎯" },
    { name: "Gopal Bajoria", amount: "₹50,400", text: "3 years party not paying. Finally account closed with full recovery.", emoji: "🔒" },
    { name: "Sunny Sharma", amount: "4 Payments", text: "Recovered 4 dead payments in a single month with the guidance", emoji: "🚀" },
    { name: "Mohammed", amount: "Target Achieved", text: "Achieved monthly target and learned profit margin tactics", emoji: "📈" },
    { name: "Roshan Patel", amount: "Multiple", text: "Magical tricks to recover payments. It's really working!", emoji: "✨" },
    { name: "Amrik Singh", amount: "Knowledge", text: "MBA classes mean a lot. Gained confidence in payment recovery", emoji: "🎓" },
    { name: "Bhupindar Singh", amount: "Expert", text: "Outstanding coach with deep expertise in recovery", emoji: "👨‍🏫" },
    { name: "Sanjay Bansal", amount: "Clarity", text: "Walked out with knowledge and confidence to handle any case", emoji: "💡" }
  ];

  return (
    <section className="relative py-20 md:py-28 bg-gradient-to-b from-gray-900 via-black to-gray-900 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-green-500/30 to-transparent"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(16,185,129,0.03),transparent_70%)]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500/10 to-emerald-500/10 border border-green-500/20 text-green-400 px-5 py-2 rounded-full text-sm font-medium mb-6">
            <span className="text-lg">💬</span>
            Success Stories
          </div>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4">
            Real People,
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400"> Real Results</span>
          </h2>
          
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Join thousands of business owners who have recovered their stuck payments
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-900/80 to-gray-800/50 rounded-2xl p-6 border border-gray-800 hover:border-green-500/40 transition-all duration-500 hover:-translate-y-2 hover:shadow-xl hover:shadow-green-500/5 backdrop-blur-sm"
            >
              {/* Hover Glow */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-green-500/5 to-emerald-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              {/* Emoji Badge */}
              <div className="absolute -top-3 -right-3 w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl flex items-center justify-center text-lg shadow-lg transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-300">
                {testimonial.emoji}
              </div>

              {/* Content */}
              <div className="relative">
                {/* Avatar & Info */}
                <div className="flex items-center gap-4 mb-4">
                  <div className="relative">
                    <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center text-white text-xl font-black shadow-lg">
                      {testimonial.name.charAt(0)}
                    </div>
                    {/* Online Indicator */}
                    <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-gray-900 flex items-center justify-center">
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h4 className="font-bold text-white group-hover:text-green-400 transition-colors">
                      {testimonial.name}
                    </h4>
                    <span className="inline-flex items-center gap-1 text-green-400 text-sm font-bold">
                      <span className="text-xs">💰</span>
                      {testimonial.amount}
                    </span>
                  </div>
                </div>

                {/* Quote */}
                <p className="text-gray-400 text-sm leading-relaxed group-hover:text-gray-300 transition-colors">
                  "{testimonial.text}"
                </p>

                {/* Stars */}
                <div className="flex gap-1 mt-4">
                  {[1, 2, 3, 4, 5].map(star => (
                    <svg key={star} className="w-4 h-4 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
